var $ = require("./..\\..\\..\\bower_components\\jquery\\dist\\jquery.js");

module.exports = function(commentary) {
  $('#commentary p').removeClass('entered');
  setTimeout(function() {
    $('#commentary p').text(commentary).addClass('entered');
  }, 300);
};
